// ScrollDepthTrigger.ts
// Mirrors ConneXt v2 ScrollDepthTrigger: scroll-depth trigger with RepeatableOnConversation + per-article stop.
import { BaseTrigger } from "./BaseTrigger";
import { ActionRepository } from "./ActionRepository";
export class ScrollDepthTrigger extends BaseTrigger {
    constructor() {
        super(...arguments);
        this.hasActionTriggerLimit = false;
        this.scrollHandler = null;
        this.element = null;
    }
    get selector() {
        return this.when.Selector || "";
    }
    get depth() {
        var _a, _b;
        return (_b = (_a = this.when.Depth) !== null && _a !== void 0 ? _a : this.when.ScrollDepth) !== null && _b !== void 0 ? _b : 50;
    }
    init() {
        if (!this.selector)
            return;
        this.element = document.querySelector(this.selector);
        if (!this.element)
            return;
        this.stopRepeatableOnScroll(true);
        this.scrollHandler = (e) => this.scrollTrigger();
        this.scrollHandler();
        window.addEventListener("resize", this.scrollHandler);
        window.addEventListener("scroll", this.scrollHandler);
    }
    stopRepeatableOnScroll(value) {
        const repeats = ActionRepository.getRepeatablesInArticle();
        repeats.stopScrollOnRepeatArticle = value;
        ActionRepository.setRepeatablesInArticle(repeats);
    }
    canScrollTrigger() {
        const repeats = ActionRepository.getRepeatablesInArticle();
        return (this.canRepeatableOnConversation() &&
            repeats.stopScrollOnRepeatArticle === true);
    }
    scrollTrigger() {
        if (this.canScrollTrigger()) {
            const scrollProgress = this.percentageSeen();
            if (scrollProgress >= this.depth || !this.hasScrollbar()) {
                if (!this.timer) {
                    this.startTimer(() => {
                        this.timer = null;
                        this.markTriggered();
                        this.actionInstance.execute();
                    });
                }
                this.stopRepeatableOnScroll(false);
            }
        }
        else if (!this.hasActionTriggerLimit) {
            this.hasActionTriggerLimit = true;
        }
    }
    percentageSeen() {
        if (!this.element)
            return 0;
        const viewportHeight = window.innerHeight;
        const scrollTop = window.pageYOffset;
        const rect = this.element.getBoundingClientRect();
        const elementOffsetTop = rect.top + scrollTop;
        const elementHeight = this.element.clientHeight;
        if (elementOffsetTop > scrollTop + viewportHeight) {
            return 0;
        }
        else if (elementOffsetTop + elementHeight < scrollTop) {
            return 100;
        }
        else {
            const distance = (scrollTop + viewportHeight) - elementOffsetTop;
            return Math.round((distance / elementHeight) * 100);
        }
    }
    hasScrollbar() {
        return document.documentElement.scrollHeight > window.innerHeight;
    }
    unRegister() {
        super.unRegister();
        if (this.scrollHandler) {
            window.removeEventListener("resize", this.scrollHandler);
            window.removeEventListener("scroll", this.scrollHandler);
        }
    }
}
